var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 12.7925L12.7929 11.4995L9.21541 7.922L11.8384 6.173L3.74591 3.7455L6.17341 11.838L7.92241 9.215L11.4999 12.7925ZM11.4999 13.9995C11.3719 13.9995 11.2439 13.9505 11.1464 13.853L8.07741 10.784L6.41591 13.277C6.30891 13.4375 6.12041 13.522 5.92591 13.494C5.73441 13.4655 5.57641 13.3285 5.52091 13.143L2.52091 3.143C2.46841 2.967 2.51641 2.776 2.64641 2.646C2.77641 2.5155 2.96791 2.468 3.14341 2.5205L13.1434 5.5205C13.3289 5.576 13.4659 5.734 13.4944 5.9255C13.5229 6.117 13.4384 6.308 13.2774 6.4155L10.7844 8.077L13.8534 11.146C14.0489 11.3415 14.0489 11.6575 13.8534 11.853L11.8534 13.853C11.7559 13.9505 11.6279 13.9995 11.4999 13.9995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardClick);
export default __webpack_public_path__ + "static/media/dashboard-click.9cace03ad2b5882ec6be64dfab1279fa.svg";
export { ForwardRef as ReactComponent };